import classNames from 'clsx';
import React from 'react';
import type { MdComponentIndexProps } from '../type';
import styles from './index.module.css';

export function MarkdownContainerBox({
  children,
  style,
  className,
  ...props
}: React.PropsWithChildren<
  {
    style?: React.CSSProperties;
    className?: string;
  } & MdComponentIndexProps
>) {
  return (
    <div
      className={classNames('markdown-child-root', className, styles.container)}
      style={style}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <>{children}</>
    </div>
  );
}

MarkdownContainerBox.attributes = ['className', 'style'];
MarkdownContainerBox.inline = false;
